{
  "Accessibility Menu": "رسائی مینو",
  "Reset settings": "ترتیبات ری سیٹ کریں",
  "Close": "بند کریں",
  "Content Adjustments": "مواد کی ایڈجسٹمنٹ",
  "Adjust Font Size": "فونٹ سائز ایڈجسٹ کریں",
  "Highlight Title": "عنوان کو نمایاں کریں",
  "Highlight Links": "لنکس کو نمایاں کریں",
  "Readable Font": "قابلِ مطالعہ فونٹ",
  "Color Adjustments": "رنگ کی ایڈجسٹمنٹ",
  "Dark Contrast": "گہرا تضاد",
  "Light Contrast": "ہلکا تضاد",
  "High Contrast": "زیادہ تضاد",
  "High Saturation": "زیادہ سیچوریشن",
  "Low Saturation": "کم سیچوریشن",
  "Monochrome": "مونوکروم",
  "Tools": "اوزار",
  "Reading Guide": "مطالعہ گائیڈ",
  "Stop Animations": "حرکات روکیں",
  "Big Cursor": "بڑا کرسر",
  "Increase Font Size": "فونٹ سائز بڑھائیں",
  "Decrease Font Size": "فونٹ سائز کم کریں",
  "Letter Spacing": "حروف کا فاصلہ",
  "Line Height": "لائن کی اونچائی",
  "Font Weight": "فونٹ کا وزن",
  "Dyslexia Font": "ڈسلیکسیا فونٹ",
  "Language": "زبان",
  "Open Accessibility Menu": "رسائی مینو کھولیں"
}
